import { DownloadIcon } from "@chakra-ui/icons";
import {
  Box,
  Link as ChakraLink,
  Container,
  Flex,
  Grid,
  Heading,
  List,
  ListIcon,
  ListItem,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { useRef } from "react";
import { AiOutlineFile, AiOutlineLink } from "react-icons/ai";
import { FormattedMessage, IntlShape, useIntl } from "react-intl";

import { Breadcrumbs } from "@nens/ldo/components";
import { useRect } from "@nens/react/hooks";

const getContactInfo = (intl: IntlShape) => [
  {
    title: intl.formatMessage({
      id: "pages.info.contact.organisation",
      defaultMessage: "Organisation",
    }),
    value: "BIJ12",
  },
  {
    title: intl.formatMessage({
      id: "pages.info.contact.email",
      defaultMessage: "Email",
    }),
    value: (
      <ChakraLink href={`mailto:beheerldo@bij12.nl`} isExternal>
        beheerldo@bij12.nl
      </ChakraLink>
    ),
  },
];

export function InfoPage() {
  const intl = useIntl();
  const boxRef = useRef<HTMLDivElement>(null);
  const rect = useRect(boxRef);

  return (
    <Box w="full" h="full">
      <Breadcrumbs
        crumbs={[
          { label: intl.formatMessage({ id: "pages.home", defaultMessage: "Home" }), href: "/" },
          {
            label: intl.formatMessage({
              id: "pages.info",
              defaultMessage: "Contact and Documentation",
            }),
            href: "/info",
          },
        ]}
      />
      <Container maxW={"7xl"} py={"24px"} justifyItems="center">
        <Tabs h="full" w="full">
          <TabList>
            <Tab>
              <FormattedMessage id="pages.info.tabs.contact" defaultMessage="Contact" />
            </Tab>
            <Tab>
              <FormattedMessage id="pages.info.tabs.guide" defaultMessage="Documentation" />
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Heading mb={3}>
                <FormattedMessage id="pages.info.tabs.contact" defaultMessage="Contact" />
              </Heading>
              {getContactInfo(intl).map(({ title, value }) => (
                <Grid
                  templateColumns="150px 150px"
                  border="1px solid #ddd"
                  p={5}
                  py={3}
                  w="fit-content"
                >
                  <Box as="strong">{title}:</Box>
                  <Box>{value}</Box>
                </Grid>
              ))}
            </TabPanel>
            <TabPanel>
              <List>
                <ListItem>
                  <Flex>
                    <Flex alignItems="center">
                      <ListIcon as={AiOutlineFile} color="bij12_1.700" />
                    </Flex>
                    <ChakraLink href="/assets/docs/LDO-handleiding.pdf" fontWeight="semibold">
                      Handreiking gebruik van de Application Programming Interface (API)
                      <DownloadIcon mx="6px" />
                    </ChakraLink>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex>
                    <Flex alignItems="center">
                      <ListIcon as={AiOutlineFile} color="bij12_1.700" />
                    </Flex>
                    <ChakraLink
                      href="/assets/docs/LDO-ROR-import-handleiding-V1.1.pdf"
                      fontWeight="semibold"
                    >
                      ROR importhandleiding voor de Landelijke Databank Overstromingsinformatie
                      (LDO)
                      <DownloadIcon mx="6px" />
                    </ChakraLink>
                  </Flex>
                </ListItem>

                <ListItem>
                  <Flex>
                    <Flex alignItems="center">
                      <ListIcon as={AiOutlineLink} color="bij12_1.700" />
                    </Flex>
                    <ChakraLink
                      href="https://iplo.nl/thema/water/beleid-regelgeving-water/europese-richtlijnen-relevant-water/europese-richtlijn-overstromingsrisico/"
                      fontWeight="semibold"
                    >
                      Europese Richtlijn Overstromingsrisico's
                    </ChakraLink>
                  </Flex>
                </ListItem>

                <ListItem>
                  <Flex>
                    <Flex alignItems="center">
                      <ListIcon as={AiOutlineLink} color="bij12_1.700" />
                    </Flex>
                    <ChakraLink
                      href="https://iplo.nl/thema/water/beleid-regelgeving-water/europese-richtlijnen-relevant-water/europese-richtlijn-overstromingsrisico/overstromingsgevaar-overstromingsrisicokaarten/leidraad/"
                      fontWeight="semibold"
                    >
                      Leidraad overstromingssimulaties
                    </ChakraLink>
                  </Flex>
                </ListItem>

                <ListItem>
                  <Flex>
                    <Flex alignItems="center">
                      <ListIcon as={AiOutlineLink} color="bij12_1.700" />
                    </Flex>
                    <ChakraLink
                      href="https://iplo.nl/thema/water/beleid-regelgeving-water/europese-richtlijnen-relevant-water/europese-richtlijn-overstromingsrisico/overstromingsgevaar-overstromingsrisicokaarten/"
                      fontWeight="semibold"
                    >
                      Handboek overstromingsrisico's op de kaart
                    </ChakraLink>
                  </Flex>
                </ListItem>
              </List>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </Box>
  );
}
